import { formatMonthParam } from '@lib/social/scheduling/window';
import { scheduleSettings } from '@stores/ScheduleSettings';
import { isSameMonth } from 'date-fns';

/**
 * The schedule page opened on the month of `publishAt` in the schedule's
 * zone; the current month needs no param, as the page itself writes it.
 */
export const schedulePath = (publishAt: number | null, now: Date): string => {
  if (publishAt === null) return '/schedule';
  const at = scheduleSettings.inZone(publishAt);
  return isSameMonth(at, now) ? '/schedule' : `/schedule?month=${formatMonthParam(at)}`;
};

export const postPath = (postId: string): string => `/schedule/post/${postId}`;

export const composePath = (renderId: string): string => `/schedule/create/${renderId}`;
